// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-coordinate"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.2725 4.22217L18.8857 8.11106V15.8888L12.2725 19.7777L5.65918 15.8888V8.11106L12.2725 4.22217Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.2724 4.22222L18.8857 8.11111V15.8889M12.2724 4.22222L5.65909 8.11111V15.8889M12.2724 4.22222V2M18.8857 15.8889L12.2724 19.7778M18.8857 15.8889L21 17M12.2724 19.7778L5.65909 15.8889M12.2724 19.7778V22M12.2724 19.7778L12.2727 12M5.65909 15.8889L3 17M12.2727 12L18.4723 8.35419M12.2727 12L6.07244 8.35419","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemCoordinateIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-coordinate',
    ref,
    icon: element,
  },
));

SystemCoordinateIcon.displayName = 'SystemCoordinateIcon';

export default SystemCoordinateIcon;
